import { render, staticRenderFns } from "./ContentInfo.vue?vue&type=template&id=511d5368&"
import script from "./ContentInfo.vue?vue&type=script&lang=js&"
export * from "./ContentInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContentInfo.vue?vue&type=style&index=0&id=511d5368&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports